import { Alert } from "react-bootstrap";
import "./ContactLibrary.scss";

interface ContactLibraryProps {}

const ContactLibrary: React.FC<ContactLibraryProps> = () => {
  const contacts = [];
  const isContactsLoading = false;

  return (
    <div className="contact-library">
      <div className="contact-library-header">Contact Library</div>
      {contacts.length === 0 && !isContactsLoading && (
        <Alert variant="warning">You don't have any contacts.</Alert>
      )}
    </div>
  );
};

export default ContactLibrary;
